<template>
  <nav class="app-bar-nav">
    <a href="/?ref=logo" class="logo" v-t:title="'Take me home'"><div class="logo-image"/></a>
    <div v-if="isUserRegistered" class="app-bar-menu" role="menubar">
      <universal-search :status="searchStatus" />
      <app-bar-help :user="user" />
      <app-bar-account :user="user" />
    </div>
    <div v-else class="app-bar-menu" role="menubar">
      <app-bar-help :user="user" />
      <a class="app-bar-button" role="menuitem" href="/auth/signup" v-t>Sign up</a>
      <a class="app-bar-button" role="menuitem" href="/auth/login" v-t>Log in</a>
    </div>
  </nav>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import UniversalSearch from 'vuecomponents/universal_search'
import AppBarHelp from 'vuecomponents/app_bar_help'
import AppBarAccount from 'vuecomponents/app_bar_account'
import t from 'vuedirectives/t'

export default {
  components: { UniversalSearch, AppBarHelp, AppBarAccount },
  directives: { t },
  props: ['user'],
  data: function() {
    return {
      searchStatus: 'collapsed',
    }
  },
  computed: {
    isUserRegistered: function() {
      return !!this.user.registered_at
    },
  },
}
</script>
